module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaWNvbnMvYXBwbGUtdG91Y2gtaWNvbi5wbmciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/apple-touch-icon.png
// module id = fpW3
// module chunks = 0